import { render, staticRenderFns } from "./hosFrom.vue?vue&type=template&id=05c730aa&"
import script from "./hosFrom.vue?vue&type=script&lang=js&"
export * from "./hosFrom.vue?vue&type=script&lang=js&"
import style0 from "./hosFrom.vue?vue&type=style&index=0&id=05c730aa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports